export default [
  {
    path: "/doctor",
    name: "doctor",
    component: () => import("@/views/hospital/Doctors.vue"),
  },
  {
    path: "/doctor-assistant",
    name: "doctor-assistant",
    component: () => import("@/views/hospital/DoctorsAssistant.vue"),
  },

  {
    path: "/doctor-preview/:id",
    name: "doctor-preview",
    component: () => import("@/views/hospital/DoctorPreview.vue"),
  },
  {
    path: "/doctor-assistant-preview/:id",
    name: "doctor-assistant-preview",
    component: () => import("@/views/hospital/DoctorAsissHistory.vue"),
  },
  {
    path: "/hospital-doctor-preview/:id",
    name: "hospital-doctor-preview",
    component: () => import("@/views/hospital/HospitalDoctorPreview.vue"),
  },
  {
    path: "/available-rooms",
    name: "available-rooms",
    component: () => import("@/views/hospital/AvailableRooms.vue"),
  },
  {
    path: "/floor",
    name: "floor",
    component: () => import("@/views/hospital/Floors.vue"),
  },
  {
    path: "/room",
    name: "room",
    component: () => import("@/views/hospital/Rooms.vue"),
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/hospital/Services.vue"),
  },
  {
    path: "/Quick-Invoice-Type",
    name: "quick-invoice-type",
    component: () => import("@/views/hospital/QuickInvoiceType.vue"),
  },
  {
    path: "/invoices/:patientId",
    name: "invoices",
    component: () => import("@/views/hospital/Invoices.vue"),
  },
  /////////////////////// hospital expenses and income ///////////////////////
  // {
  //   path: '/hospital-expenses',
  //   name: 'hospital-expenses',
  //   component: () => import('@/views/hospital/HospitalExpenses.vue'),
  // },
  // {
  //   path: '/hospital-income',
  //   name: 'hospital-income',
  //   component: () => import('@/views/hospital/HospitalIncome.vue'),
  // },
  // {
  //   path: '/hospital-exchange-rate',
  //   name: 'hospital-exchange-rate',
  //   component: () => import('@/views/hospital/HospitalExchangeRate.vue'),
  // },
];
